import { QuotaionAPI } from "../api";
import { DocumentItem } from "./DocumentItem.class";
import Helper from "../plugins/Helper/Helper";
import moment from "moment"
import Vue from "vue";
export class Quotation {
  constructor(data) {
    this.className = data.className
    this.objectId = data.objectId || data.id
    this.isVatInclusive = data.isVatInclusive || false
    this.project = data.project
    this.market = data.market
    this.runningNumber = data.runningNumber
    this.runningMonth = data.runningMonth
    this.runningYear = data.runningYear
    this.isSent = data.isSent
    this.isPaid = data.isPaid
    this.areaInterest = data.areaInterest
    this.documentId = data.documentId
    this.documentType = data.documentType
    this.companyData = data.companyData || {}
    this.customerData = data.customerData || {}
    this.date = data.date && data.date.iso ? data.date.iso : null
    this.dueDate = data.dueDate && data.dueDate.iso ? data.dueDate.iso : null
    this.note = data.note || ""
    this.vatPercent = data.vatPercent || Vue.prototype.$globalVatPercent || 7
    this.isVat = data.isVat
    this.createdBy = data.createdBy || null
    this.updatedByText = data.updatedBy ? `${data.updatedBy.firstName} ${data.updatedBy.lastName}` : ''
    this.updatedAtText = data.updatedAt ? moment(data.updatedAt).format('DD MMM YYYY, HH:mm') : ''
    this.currencyCode = data.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
    const items = data?.items?.filter(d => {
      const area = d.area ? d.area : { isRemove: true, name: "-" };
      d.area = area;
      return d;
    });
    this.items = [];
    if (data.items && data.items.length) {
      for (let item of items) {
        this.items.push(
          new DocumentItem(
            item,
            data.isVatInclusive,
            this.vatPercent,
          )
        );
      }
    } else {
      this.items.push(
        new DocumentItem(
          {},
          this.isVatInclusive,
          this.vatPercent,
        )
      );
    }

  }

  static async getQuotation(quotaionId) {
    const { data } = await QuotaionAPI.getQuotation(quotaionId)
    return new Quotation(data.result);
  }

  static async createQuotation(postData) {
    const { data } = await QuotaionAPI.createQuotation(postData);
    return new Quotation(data.result);
  }

  static async updateQuotation(postData) {
    const { data } = await QuotaionAPI.updateQuotation(postData);
    return new Quotation(data.result);
  }

  static async sendQuotation({ id, date, dueDate }) {
    const { data } = await QuotaionAPI.sendQuotation({ id, date, dueDate });
    return new Quotation(data.result);
  }

  static async unsendQuotation(invoiceId) {
    const { data } = await QuotaionAPI.unsendQuotation(invoiceId);
    return new Quotation(data.result);
  }

  get totalOriginalValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0)
    );
  }

  get totalVatValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalVatValue || 0), 0)
    );
  }

  get totalValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalValue || 0), 0)
    );
  }

  get totalNonVatValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalVatItemsValue() {
    return Helper.round(
      this.items
        .filter(d => {
          return d.sellVatType == 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalNonVatItemsValue() {
    return Helper.round(
      this.items
        .filter(d => {
          return d.sellVatType != 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalWhtValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalWhtValue || 0), 0)
    );
  }

  get totalUnpaidValue() {
    if (this.isSent) return Helper.round(this.totalValue - this.totalPaidValue);
    else return 0;
  }

  get createdByFullName() {
    if (this.createdBy)
      return `${this.createdBy.firstName || ""} ${this.createdBy.lastName || ""}`;
    else
      return "";
  }

  get totalDiscountValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalDiscountValue || 0), 0)
    );
  }
}
